const initState = {
  transactionHistoryOffice: []
}

export default initState;
